import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {IdMapper} from "@/interfaces/state/base";
import {LadingError} from "@/interfaces/entity/ladingerror";
import {LadingErrorParams} from "@/modules/ladingerror/params";
import {PaginationMeta} from "@/interfaces/common";
import {LadingErrorCustomerState} from "@/modules/ladingerrorcustomer/state";
import {
    listLadingErrorCustomer,
    responseLadingErrorCustomer,
    singleLadingErrorCustomer
} from "@/modules/ladingerrorcustomer/service";
import {LadingErrorCustomerParams} from "@/modules/ladingerrorcustomer/params";

@Module({dynamic: true, name: "ladingErrorCustomer", store})
class LadingErrorCustomerModule extends VuexModule implements LadingErrorCustomerState {
    data: IdMapper<LadingError> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: LadingErrorCustomerParams = new LadingErrorCustomerParams();

    @Mutation
    private UPDATE_LADING_ERROR_CUSTOMER_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private UPDATE_LADING_ERROR_CUSTOMER(payload: LadingError) {
        if(!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = {...payload}
    }
    @Mutation
    private MAP_LADING_ERROR_CUSTOMER(payload: any) {
        const idMapper: IdMapper<LadingError> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((ladingError: LadingError, index: any) => {
            idMapper[ladingError.id!] = {...ladingError, stt: index + 1};
            return ladingError.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_LADING_ERROR_CUSTOMER(payload: LadingError){
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids =  [...this.ids, payload.id];
        this.data = {...this.data, [payload.id]: {...payload}}
    }

    @Action({rawError: true})
    public async listLadingErrorCustomer(params: LadingErrorParams = new LadingErrorParams()) {
        const {data} = await listLadingErrorCustomer(params);
        this.MAP_LADING_ERROR_CUSTOMER(data);
    }

    @Action({rawError: true})
    public async singleLadingErrorCustomer(id: number) {
        const {data} = await singleLadingErrorCustomer(id);
        return data.data;
    }

    @Action({rawError: true})
    public async responseLadingErrorCustomer(dataReq: any) {
        const {data} = await responseLadingErrorCustomer(dataReq);
        this.UPDATE_LADING_ERROR_CUSTOMER(data.data);
    }

    @Action({rawError: true})
    public updateLadingErrorCustomerParams(payload: any) {
        this.UPDATE_LADING_ERROR_CUSTOMER_PARAMS(payload);
    }

}

export const LadingErrorCustomerStore = getModule(LadingErrorCustomerModule)
